import { defineComponent, computed, ref } from "vue";
import { definePropType } from "@types-vue/props";
import FontLayer from "@com/components/font-layer/index.vue";
import _ from "lodash";
export default defineComponent({
    props: {
        forbiddenFontList: {
            type: definePropType(Object),
            default: function() {}
        },
        fontOptions: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        tool: {
            type: Number,
            default: 1
        },
        assetFontConfig: {
            type: definePropType(Object),
            default: function() {}
        }
    },
    components: {
        FontLayer: FontLayer
    },
    setup: function setup(props) {
        var manageForbiddenFontRef = ref();
        var fontSelectorLoading = ref(false);
        var fontSelectorConfig = computed(function() {
            return {
                prop: "postscript_name",
                field: {
                    options: props.fontOptions,
                    clearable: true
                }
            };
        });
        var offsetConfigHeight = computed(function() {
            var clientHeight = manageForbiddenFontRef.value && manageForbiddenFontRef.value.clientHeight + 48;
            var height;
            if (clientHeight < 414) {
                height = "478";
            } else if (clientHeight > 464) {
                height = "680";
            } else {
                height = clientHeight + 66;
            }
            return height + "px";
        });
        var updateFont = function(font, language, index) {
            var fontValue = font.value.postscript_name === "system-font" ? {} : font.value;
            _.set(props.forbiddenFontList, "".concat(language, "[").concat(index, "].newFont"), fontValue);
        };
        var getPostscriptName = function(name) {
            // 处理自定义字体展示问题 自定义字体:id|name组成，只需要展示name
            return name && name.split("|").length > 1 ? name.split("|")[1] : name;
        };
        return {
            offsetConfigHeight: offsetConfigHeight,
            manageForbiddenFontRef: manageForbiddenFontRef,
            fontSelectorConfig: fontSelectorConfig,
            fontSelectorLoading: fontSelectorLoading,
            updateFont: updateFont,
            getPostscriptName: getPostscriptName
        };
    }
});
